module.exports = {"440705001":"会城街道","440705101":"大泽镇","440705102":"司前镇","440705103":"罗坑镇","440705104":"双水镇","440705105":"崖门镇","440705106":"沙堆镇","440705107":"古井镇","440705108":"三江镇","440705109":"睦洲镇","440705110":"大鳌镇","440705450":"圭峰区","440705451":"银湖湾","440705452":"银湖湾滨海新区","440705453":"工业园区","440705470":"新会经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440705.json
// module id = 2118
// module chunks = 0